import { render } from "./RetrievalLab.vue?vue&type=template&id=76936ed0&scoped=true"
import script from "./RetrievalLab.vue?vue&type=script&lang=js"
export * from "./RetrievalLab.vue?vue&type=script&lang=js"

import "./RetrievalLab.vue?vue&type=style&index=0&id=76936ed0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76936ed0"]])

export default __exports__